import { useMemo, useRef, useState, useEffect, useCallback } from 'react';
import { Button, Dropdown, Form, FormControl, FormText, ListGroup } from "react-bootstrap"
import TagsInput from "react-tagsinput"
import { WithContext as ReactTags, SEPARATORS } from 'react-tag-input';
import defaultImage from "../images/pimage.png"
import { Close, CloseIcon, FileIcon, UploadIcon } from './icons';
import clsx from "clsx"
import { Skills } from "./joblist";
import AzureBlob from '../utils/azureblob';
import PDFViewer from './pdfviewer';
import request from '../utils/request';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import routes from '../utils/routes';
import { useSelector } from 'react-redux';
import { Eye, EyeSlash } from './icons';


const defaultContainerStyle = {
    display: "flex",
    flexDirection: "column",
    width: "100%",

}
const defaultLabelStyle = {
    width: "100%",

}
export default function formRender({
    key,
    options,
    type,
    binder,
    required,
    onChange,
    rows,
    containerStyle = defaultContainerStyle,
    labelContainerStyle = defaultLabelStyle,
    inputContainerStyle = defaultLabelStyle,
    labelStyle = {},
    label,
    placeholder,
    accept,
    returnOnlyInput = false,
    defaultValue,
    ...rest
}: any) {

    binder = binder || defaultValue || "";
    const render = () => {
        options = typeof options === "function" ? options() : options;
        switch (type) {
            //provide a case for password
            case 'password': {

                return <PasswordField
                    name={key}
                    value={binder}
                    onChange={onChange}
                    required={required}
                    placeholder={placeholder}
                    {...rest}
                />
            }
            case 'tags': {
                if (typeof binder === "string") {
                    binder = [];
                }
                return <>
                    <Tags binder={binder} formKey={key} onChange={onChange} {...rest} />
                    <Form.Text >press enter after each item</Form.Text>
                </>
            }
            case 'select': {
                return <Form.Select {...rest} name={key} onChange={onChange} value={binder}  >
                    {
                        options.map((value: any, key: any) => {
                            return <option key={key} value={value.value}>{value.label}</option>
                        })
                    }
                </Form.Select>
            }
            case 'customSelect': {
                return <Form.Select {...rest} name={key} onChange={onChange} value={binder}  >
                    {
                        options.map((value: any, key: any) => {
                            return <option key={key} value={value.value}>{value.label}</option>
                        })
                    }
                </Form.Select>
            }
            case 'textarea': {
                return <Form.Control name={key} onChange={onChange} value={binder} as={"textarea"} rows={rows} />
            }
            case 'customImage': {
                return <CustomImage binder={binder} accept={accept} name={key} onChange={onChange} />
            }
            case 'customFile': {
                return <CustomFile binder={binder} accept={accept} name={key} onChange={onChange} {...rest} />
            }
            case 'autoComplete': {
                return <AutoComplete name={key} onChange={onChange} value={binder} type={type} accept={accept} required={required} placeholder={placeholder} {...rest} />
            }
            case 'customLocation': {
                return <CustomLocation name={key} onChange={onChange} binder={binder} type={type} accept={accept} required={required} placeholder={placeholder} {...rest} />
            }
            default: {
                return <Form.Control name={key} onChange={onChange} value={binder} type={type} accept={accept} required={required} placeholder={placeholder} {...rest} />
            }
        }
    }



    return <>
        {
            returnOnlyInput ? <>{render()}</> :
                <div key={key} style={containerStyle}>
                    <div style={labelContainerStyle}>
                        <Form.Label style={labelStyle}>
                            {label}
                        </Form.Label>
                    </div>
                    <div style={inputContainerStyle}>
                        {render()}
                    </div>
                </div>
        }
    </>
}

//for password
const PasswordField = ({ name, value, onChange, required, placeholder, ...rest }: any) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePasswordVisibility = (key: any) => {
        setShowPassword(!showPassword)

    };
    return (
        <div className='password-divs'>
            <Form.Control
                className='input-login'
                name={name}
                onChange={onChange}
                value={value}
                type={showPassword ? 'text' : 'password'}
                required={required}
                placeholder={placeholder}
                {...rest}
            />
            <button
                className='btn-login-divs'
                style={{ border: 'none', background: 'none' }}
                onClick={handleTogglePasswordVisibility}
            >
                {showPassword ? <Eye /> : <EyeSlash />}
            </button>
        </div>
    );

}

const CustomLocation = (props: any) => {
    const { onChange, name: inputName, accept, binder, folder = "tracker/images"
    } = props;
    const { countries } = useSelector((state: any) => state.appReducer.combos)
    const [states, setStates] = useState<any>({});
    const [cities, setCities] = useState<any>({});
    const [stateLoading, setStateLoading] = useState(false);
    const [cityLoading, setCityLoading] = useState(false)
    const dispatch = useDispatch();

    const APITOKEN = "qIxcpJegCJDYKLT1z3j3o1kwOvK1Qt46yV_7U5GQsyIrz_yAxhhdQLGOYPp0hbwdqZk"
    const [data, setData] = useState({
        country: '',
        state: '',
        city: ''
    })
    const [token, setToken] = useState<string>('');

    const onChangeState = async (evt: any) => {
        const { name, value } = evt.target;
        let outValue = [];
        if (name === "country") {
            outValue.push(value);
            //  setData(prev => ({ ...prev, state: '', city: '', [name]: value }))

        } else if (name === "state") {
            outValue.push(...[data.country, value]);
            //setData(prev => ({ ...prev, city: '', [name]: value }))
        } else {
            outValue.push(...[data.country, data.state, value]);
            // setData(prev => ({ ...prev, [name]: value }))
        }

        onChange({ target: { name: inputName, value: outValue.reverse().join(",") } })
    }
    const fetchEveryThing = async (data: any) => {
        let tokens

        if (!data.country) return
        if (!states[data.country]) {
            setStateLoading(true);
            const [states, auth] = await callAPI(`/states/${data.country}`, tokens);
            tokens = auth;
            setStates({ [data.country]: states })
            setCities({})
            setStateLoading(false);
        }
        if (!data.state) return;


        if (!cities[data.state]) {
            setCityLoading(true);
            const [cities, auth] = await callAPI(`/cities/${data.state}`, tokens);
            setCities({ [data.state]: cities });
            setCityLoading(false);
        }
    }


    useEffect(() => {
        fetchEveryThing(data);
    }, [data])


    useEffect(() => {
        const data = binder?.split(",") || [];
        if (!data.length) return;
        const len = data.length;
        let city = '', country = '', state = '';
        let setdata: any = {}
        if (len === 1) {
            [country] = data
        } else if (len === 2) {
            [state, country] = data;
        } else {
            [city, state, country] = data;
        }

        console.log("from binder", { city, state, country })
        if (binder) {
            setData({ city, state, country })
        }
    }, [binder])



    const getToken = async () => {
        const token = await request({
            url: `${routes.locationAPI}/getaccesstoken`,
            options: {
                headers: {
                    accept: "application/json",
                    "api-token": APITOKEN,
                    "user-email": "snduaguibe@atb.tech"
                }
            },
            method: "GET",
            dispatch,
            useBaseUrl: false,
            useLoader: false
        })
        setToken(token.auth_token);
        return token.auth_token;
    }

    const callAPI = async (path: string, tokens?: string) => {

        if (!tokens && !token) {
            tokens = await getToken();
        }
        return [await request({
            url: `${routes.locationAPI}${path}`,
            options: {
                headers: {
                    authorization: `Bearer ${tokens || token}`,
                }
            },
            method: "GET",
            dispatch,
            useBaseUrl: false,
            useLoader: false
        }), tokens]
    }

    return <>
        <div className="d-flex ">
            <Form.Select name={"country"} onChange={onChangeState} value={data.country}  >
                <option value="">Country</option>
                {
                    countries.map((value: any, key: any) => {
                        return <option key={key} >{value.country_name}</option>
                    })
                }
            </Form.Select>
            <Form.Select disabled={stateLoading} name={"state"} onChange={onChangeState} value={data.state}  >
                <option value="">{stateLoading ? "loading.." : "State"}</option>
                {
                    (states[data.country] || []).map((value: any, key: any) => {
                        return <option key={key} >{value.state_name}</option>
                    })
                }
            </Form.Select>
            <Form.Select disabled={cityLoading} name={"city"} onChange={onChangeState} value={data.city}  >
                <option value="">{cityLoading ? "loading.." : "City"}</option>
                {
                    (cities[data.state] || []).map((value: any, key: any) => {
                        return <option key={key} >{value.city_name}</option>
                    })
                }
            </Form.Select>
        </div>
    </>
}
const CustomImage = (props: any) => {
    const { onChange, name, accept, binder, folder = "tracker/images" } = props
    const file = useRef<HTMLInputElement>(null);
    const [imgInfo, setImgInfo] = useState<any>([]);
    const [loading, setLoading] = useState(false)
    const uploadFile = async function (props: any) {
        const file = imgInfo[0];
        const url = new AzureBlob("img");
        const [ext] = /\.([a-zA-Z]+)$/g.exec(file.name) || [];
        setLoading(true);
        const fileUrl = await url.uploadFile({ file: file, fileName: `${folder}/${Date.now()}${ext}` });
        setLoading(false);
        setImgInfo([])
        onChange({ target: { name, value: fileUrl } })
    }
    const uploadButton = ({ hasFile, onClick, url, disabled = false, reSelect }: any) => {
        return <>{hasFile ? <Button variant="primary" onClick={reSelect} >
            <FileIcon /> <span className='hideOnMobile'>Reselect File</span>
        </Button> : null}
            <Button disabled={disabled} variant="secondary" onClick={onClick} >
                {loading ? <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div> : <>
                    {hasFile ? <><UploadIcon />  Upload </> : <> <FileIcon /> {url ? 'Change File' : 'Select File'} </>}</>}
            </Button></>
    }
    return <>
        <img src={binder || defaultImage} style={{ cursor: "pointer" }} className="info-Image" onClick={(e) => file.current?.click()} alt="passport" />
        <input hidden type="file" ref={file} onChange={(e) => setImgInfo(e.target?.files)} name={name} accept={accept} />
        {uploadButton({ hasFile: imgInfo.length, url: binder, reSelect: () => { file.current?.click() }, onClick: () => { imgInfo.length ? uploadFile(file) : file.current?.click() } })}

    </>
}

const CustomFile = (props: any) => {
    const { useAddMore = true, defaultFiles = [], onChange, addMoreText = "Add", folder = '' } = props;
    const [filesToDisplay, setFilesToDisplay] = useState<any>([]);
    useEffect(() => {
        let items = []
        for (let item of defaultFiles) {
            items.push({
                ...item,
                name: item.name,
                Component: FileComponent,
            })
        }
        setFilesToDisplay(items)

    }, [defaultFiles])
    const FileComponent = ({ name, setName, setFiles, index, editable = true, accept = "application/pdf", ...rest }: any) => {
        const file = useRef<HTMLInputElement>(null);
        const [fileInfo, setFileInfo] = useState<any>([]);
        const [loading, setLoading] = useState(false)
        const uploadButton = ({ hasFile, onClick, url, disabled = true, reSelect }: any) => {
            return <>{hasFile ? <Button onClick={reSelect} variant="primary" className='button-shared-style re-select-file-btn' >
                <FileIcon />  <span className='hideOnMobile'>Reselect File</span>
            </Button> : null}
                <Button disabled={disabled} variant="secondary" onClick={onClick} className='button-shared-style' >
                    {loading ? <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div> : <>
                        {hasFile ? <><UploadIcon /> <span className='hideOnMobile'>Upload</span>  </> : <> <FileIcon /> <span className='hideOnMobile'>{url ? 'Change File' : 'Select File'}</span> </>}</>}
                </Button></>
        }
        const uploadFile = async function (props: any) {
            const file = fileInfo[0];
            const url = new AzureBlob("doc");
            const [ext] = /\.([a-zA-Z]+)$/g.exec(file.name) || [];
            setLoading(true);
            const fileUrl = await url.uploadFile({ file: file, fileName: `${folder}/${Date.now()}${ext}` });
            setLoading(false);
            fileUrl && setFiles(fileUrl)
        }
        return <div className="d-flex w-100 justify-content-center align-items-center ">
            <div className="col-6">
                {!editable ? <FormText > {name}</FormText> : <FormControl placeholder='Name of Document' type="text" value={name || ""} onChange={setName} />}
            </div>
            <div className="col-5 d-flex justify-content-end">
                {uploadButton({ hasFile: fileInfo.length, url: rest.url, reSelect: () => { file.current?.click() }, onClick: () => { fileInfo.length ? uploadFile(file) : file.current?.click() }, disabled: !name })}
                <input hidden ref={file} onChange={(e) => setFileInfo(e.target.files)} name={name} type={"file"} accept={accept} />
                <PDFViewer url={rest.url} />
            </div>

        </div>
    }

    return <>
        <div className='d-flex  flex-column mb-3'>
            {
                filesToDisplay.map((value: any, i: number) => {
                    const { Component, editable = true, ...rest } = value;
                    return <div key={i} className='mb-2 w-100 d-flex'>
                        <Component {...rest}
                            index={i}
                            editable={editable}
                            setFiles={(value: string) => {
                                filesToDisplay[i] = {
                                    ...filesToDisplay[i],
                                    url: value
                                }
                                setFilesToDisplay([...filesToDisplay]);
                                onChange(filesToDisplay)
                            }}

                            setName={(e: any) => {
                                filesToDisplay[i] = {
                                    ...filesToDisplay[i],
                                    name: e.target.value
                                }
                                setFilesToDisplay([...filesToDisplay]);
                            }} />
                        {editable ?
                            <div >
                                <span className='clickable' onClick={() => {
                                    const temp = [...filesToDisplay];
                                    temp.splice(i, 1);
                                    setFilesToDisplay((prev: any) => ([...temp]))
                                    onChange(temp)
                                }}> <CloseIcon /> </span>
                            </div> : null}
                    </div>
                })
            }
            <div className='d-flex  mt-1 p-1 justify-content-end'>
                {useAddMore ? <Button onClick={() => {
                    setFilesToDisplay((prev: any) => ([...prev, { Component: FileComponent }]))
                }} variant='success'>{addMoreText}</Button> : null}
            </div>
        </div>
    </>

}

export function FormRenderMod({
    key,
    options,
    type,
    binder,
    name,
    required,
    onChange,
    rows,
    containerStyle = defaultContainerStyle,
    labelContainerStyle = defaultLabelStyle,
    inputContainerStyle = defaultLabelStyle,
    labelStyle = {},
    label,
    placeholder,
    accept,
    returnOnlyInput = false,
    ...rest
}: any) {

    const render = () => {
        options = typeof options === "function" ? options() : options;
        switch (type) {
            case 'tags': {
                if (typeof binder === "string") {
                    binder = [];
                }
                return <>
                    <TagsInput key={key}
                        inputProps={{ placeholder: "Enter Skill" }}
                        maxTags={6}
                        renderTag={(props: any) => {
                            let { tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other } = props
                            return <span className="tag" key={key} {...other}>
                                <div className="d-flex m-2">
                                    <Skills text={getTagDisplayValue(tag)} />
                                    <a className={clsx(classNameRemove, 'cursor-pointer', 'tag')} onClick={(e) => onRemove(key)} > <Close /></a>
                                </div>
                            </span>
                        }}
                        renderInput={(props) => {
                            let { onChange, value, addTag, ...other } = props
                            return (
                                <Form.Control type='text' onChange={onChange} value={value} {...other} />
                            )
                        }}
                        renderLayout={(tagElements, inputElement) => {
                            return <div className="d-flex flex-column">
                                <div className="d-flex mb-3">
                                    {tagElements}
                                </div>
                                {inputElement}
                            </div>
                        }}
                        onChange={(e: any) => {
                            onChange({ target: { value: e, name: key } })
                        }}
                        value={binder}

                    />
                    <Form.Text >press enter after each item</Form.Text>
                </>
            }
            case 'select': {
                return <Form.Select {...rest} name={key} onChange={onChange} value={binder}  >
                    {
                        options.map((value: any, key: any) => {
                            return <option key={key} value={value.value}>{value.label}</option>
                        })
                    }
                </Form.Select>
            }
            case 'textarea': {
                return <Form.Control name={name} onChange={onChange} value={binder} as={"textarea"} rows={rows} />
            }
            case 'customImage': {
                return <CustomImage binder={binder} accept={accept} name={key} onChange={onChange} />
            }
            case 'customFile': {
                return <CustomFile binder={binder} accept={accept} name={key} onChange={onChange} {...rest} />
            }
            default: {
                return <Form.Control name={name} onChange={onChange} value={binder} type={type} accept={accept} required={required} placeholder={placeholder} {...rest} />
            }
        }
    }


    return <>
        {
            returnOnlyInput ? <>{render()}</> :
                <div key={key} style={containerStyle}>
                    <div style={labelContainerStyle}>
                        <Form.Label style={labelStyle}>
                            {label}
                        </Form.Label>
                    </div>
                    <div style={inputContainerStyle}>
                        {render()}
                    </div>
                </div>
        }
    </>
}

const AutoComplete = ({ name, onChange, suggestion = [], label, value, placeholder, onFilter, ...rest }: any) => {
    const [activeSuggestion, setActiveSuggestion] = useState(0);
    const [filteredSuggestion, setFilteredSuggestion] = useState([]);
    const [showOptions, setShowOptions] = useState(false);
    const getFilteredSuggestion = (evt: any) => {
        const { value } = evt.target;
        let allList = [];
        if (typeof onFilter === "function") {
            allList = onFilter(suggestion)
        } else {
            allList = suggestion;
        }
        const regExp = new RegExp(value, "gi");

        const filteredList = allList.filter((val: any) => {
            return regExp.test(val)
        })
        setFilteredSuggestion(filteredList);
        setShowOptions(true);
        onChange({ target: { name, value } })
    }

    return <><Form.Control name={name} onChange={getFilteredSuggestion} value={value} placeholder={placeholder} {...rest} />
        {filteredSuggestion.length ? <div className="auto-pop-wrapper">
            {(value && showOptions) && <div className="auto-pop">
                {
                    filteredSuggestion.length ? <>
                        {filteredSuggestion.map((value, i) => {
                            return <div onClick={() => {
                                onChange({ target: { name, value } });
                                setFilteredSuggestion([]);
                                setActiveSuggestion(-1);
                                setShowOptions(false);
                            }} key={i} className={clsx('clickable', {
                                "active-suggestion": i === activeSuggestion
                            })}> {value} </div>
                        })
                        }
                    </> : null

                }
            </div>
            }
        </div> : null}
    </>
}
const Tags = ({ url, binder, onChange, formKey }: any) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [tags, setTags] = useState<any>([])
    const [value, setValue] = useState<any>([]);
    useEffect(() => {
        let temp: any[] = [];
        for (let item of binder) {
            temp.push({
                id: item.skill,
                skill: item.skill,
                text: item.skill,
                rating: item.rating
            })
        }
        setValue(temp);
    }, [binder])

    useEffect(() => {
        (async () => {
            const result = await request({
                url: url,
                method: "GET",
                dispatch,
                navigate,
            })
            const data = result?.payload?.data;
            let temp = []
            for (let item of data) {
                temp.push({
                    skill: item.name,
                    text: item.name,
                    id: item.name,
                    rating: 5
                })
            }
            setTags(temp)
        })()
    }, [])
    return <ReactTags
        tags={value}
        inline={true}
        separators={[SEPARATORS.TAB, SEPARATORS.SPACE, SEPARATORS.COMMA]}
        suggestions={tags}
        inputProps={{
            className: "form-control"
        }}
        classNames={{
            root: '',
            rootFocused: '',
            selected: 'selectedClass',
            selectedTag: '',
            selectedTagName: 'skill-container',
            search: '',
            searchInput: '',
            suggestions: 'suggestionsClass',
            suggestionActive: 'activeSuggestionClass',
            suggestionDisabled: '',
        }}
        removeComponent={({ onRemove, ...rest }) => {
            return <CloseIcon className="clickable" onClick={onRemove} />
        }}
        // inline={false}
        delimiters={[188, 13]}
        handleDelete={(i) => {
            binder.splice(i, 1);
            value.splice(i, 1)
            setValue(value)
            onChange({ target: { value: binder, name: formKey } })
        }}
        handleAddition={(i) => {
            binder.push({
                skill: i.text,
                rating: 5
            })
            value.push(i)
            setValue(value)
            onChange({ target: { value: binder, name: formKey } })
        }}
        // handleDrag={handleDrag}
        // handleTagClick={handleTagClick}
        inputFieldPosition="top"
        autocomplete
    />
}